
import React from "react"
import { Link } from "react-router-dom"

import {
    Box,
    Button,
    Flex,
    Image,
    Heading,
    Stack,
    Text, Container, Grid, SimpleGrid, Card, CardBody, CardHeader, CardFooter, Center, HStack, VStack,
} from '@chakra-ui/react';

import Navbar from './navbar';

import Sunrise from "../images/sunrisegrb/DSC_0775e.JPG";
import Omni from "../images/omnidial/rewards1.png";
import Z3 from "../images/z3leo/productoptions2.png";


let products = [
    {"title": "SunriseRGB", "description": "A compact, reprogrammable led strip controller", "url": "sunrisergb", "image": Sunrise, "background": "linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)"},
    {"title": "Z3 Leo", "description": "A tiny microcontroller that fits inside a USB port", "url": "z3leo", "image": Z3, "background": "linear-gradient(to right, green, blue, purple)"},
    {"title": "Omni Dial", "description": "A more intuitive way to use your computer", "url": "omnidial", "image": Omni, "background": "linear-gradient(to right, red, orange, yellow)"}
];

export default function Products() {
    return (
        <>
            <Navbar/>

            <Flex
                align="center"
                justify={{ base: "center", md: "space-around", xl: "space-between" }}
                direction={{ base: "column"}}
                wrap="no-wrap"
                minH="70vh"
                px={{base: 4, md: 8}}
                mb={16}
            >

                <VStack
                    spacing={8}
                >
                    {
                        products.map((item, index) =>
                            <Box
                                direction={{ base: 'column', md: "row" }}
                                variant='outline'
                                bg="rgba(255, 255, 255, 0.05)"
                                backdropFilter="blur(10px)"
                                border="1px solid rgba(255, 255, 255, 0.2)"
                                w={{base: "100%", md: "100%", lg: "800px"}}
                                maxW={{base: "600px", md: '3000px' }}
                                minH="200px"
                                key={index}
                                rounded="1rem"
                                p={{base: 8, md: 6}}
                                shadow="2xl"
                            >
                                <Stack
                                    direction={{base: "column", md: "row"}}
                                    spacing={8}
                                >
                                    <Image
                                        // objectFit='cover'
                                        maxW={{ base: "450px", md: '250px' }}
                                        w={{ base: '100%' }}
                                        src={item.image}
                                        alt='Caffe Latte'
                                        // style={{alignSelf: { base: 'center', md: "start"}}}
                                        alignSelf={{ base: 'center', md: "center"}}
                                        // mt={{base: 8, md: 0}}
                                        // ml={{md: 4}}
                                        shadow="2xl"
                                        rounded="1rem"
                                        loading="lazy"
                                    />

                                    {/*<VStack>*/}
                                    <Box>
                                        <Heading size='lg' pr={{md: 4 }} mb={2}>{item.title}</Heading>

                                        <Text py='2' pr={{md: 4 }}>
                                            {item.description}
                                        </Text>

                                        <Link to={item.url}>
                                            <Button
                                                bg="rgba(255, 255, 255, 0.1)"
                                                backdropFilter="blur(10px)"
                                                border="1px solid rgba(255, 255, 255, 0.3)"
                                                borderRadius="8px"
                                                height="50px"
                                                mt={6}
                                                color="#ffffff"
                                                _hover={{ bg: "rgba(255, 255, 255, 0.2)" }}
                                            >
                                                Learn More
                                            </Button>
                                        </Link>

                                    </Box>

                                    {/*</VStack>*/}

                                </Stack>

                            </Box>
                        )
                    }
                </VStack>

                <Text pt={8}>© AnomalyWC {new Date().getFullYear()} - △ ☽ α</Text>

            </Flex>
        </>
    );
}